export default "__VITE_ASSET__mE0knuPB__";